import {
  LinearProgress,
  LinearProgressProps,
  Stack,
  Typography
} from "@mui/material";
import { forwardRef } from "react";

interface Props extends Omit<LinearProgressProps, "value"> {
  value: number;
}

export const KpisLinearProgress = forwardRef<HTMLDivElement, Props>(
  ({ value = 0, sx, ...props }, ref): JSX.Element => {
    let displayText = "-";
    displayText = `${Math.round(value || 0)}%`;

    const clampedValue = value > 100 ? 100 : value;

    return (
      <Stack
        ref={ref}
        direction="row"
        alignItems="center"
        gap={1}
        className="kpis-linear-progress"
      >
        <LinearProgress value={clampedValue} sx={sx} {...props} />
        <Typography variant="body2" minWidth="4ch" textAlign="right">
          {displayText}
        </Typography>
      </Stack>
    );
  }
);
KpisLinearProgress.displayName = "KpisLinearProgress";
